export default {"src":"/_next/static/media/post-facebook.b90a2da5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};